import {
  api_react_v1_titv_past_events_by_network_path,
  api_react_v1_titv_past_events_path,
} from '@routes';

import request from './request';

export const TITV_PAST_EVENTS_KEY = 'titv_past_events';

export interface TITVEvent {
  id: number;
  coverUrl: string;
  date: string;
  datetime: string;
  description: string;
  duration: string;
  guid: string;
  title: string;
  videoId: string;
}

export interface LiveStream {
  networkId?: number | null;
  networkTitle?: string | null;
  streamingTitle?: string;
  videoId: string;
}

export interface TITVPastEventsResponse {
  currentPage: number;
  events: TITVEvent[];
  totalPages: number;
}

interface TITVEventsRequest {
  page: number;
  page_size: number;
}

interface TITVEventsByNetworkRequest extends TITVEventsRequest {
  network_id: number;
}

export async function fetchTITVPastEvents(
  params: TITVEventsRequest
): Promise<TITVPastEventsResponse> {
  const response = await request('get', api_react_v1_titv_past_events_path(params));
  return response;
}

export async function fetchTITVPastEventsByNetwork(
  params: TITVEventsByNetworkRequest
): Promise<TITVPastEventsResponse> {
  const response = await request('get', api_react_v1_titv_past_events_by_network_path(params));
  return response;
}
